<p>insurance-details-dialog works!</p>
